import api from 'api/axiosInstance';
import { AxiosRequestConfig } from 'axios';

export const validateSteuernummer = async (
  state: string,
  steuernummer: string,
  config?: AxiosRequestConfig,
): Promise<{ valid: boolean }> => {
  const data = await api.post(
    `v1/users/check/tax-number`,
    {
      state,
      steuernummer,
    },
    { ignoreToast: true, ...config },
  );

  return data as any;
};
